/** Prefill one-shot: solo se escribe desde landing bienvenida (HU 8337 Fase 3). */
export const LOGIN_PREFILL_LANDING_KEY = 'login-prefill-landing';

export interface LoginPrefillFromLanding {
  tipoDocumento: string | number;
  numeroDocumento: string;
  fromLanding: true;
}

export function saveLoginPrefillFromLanding(
  tipoDocumento: string | number | null | undefined,
  numeroDocumento: string | null | undefined
): void {
  if (tipoDocumento == null || tipoDocumento === '') {
    return;
  }
  const numero = String(numeroDocumento ?? '').trim();
  if (!numero) {
    return;
  }
  const payload: LoginPrefillFromLanding = {
    tipoDocumento,
    numeroDocumento: numero,
    fromLanding: true,
  };
  sessionStorage.setItem(LOGIN_PREFILL_LANDING_KEY, JSON.stringify(payload));
}

/** Lee y elimina el prefill. Si no viene de landing, no aplica. */
export function consumeLoginPrefillFromLanding(): LoginPrefillFromLanding | null {
  try {
    const raw = sessionStorage.getItem(LOGIN_PREFILL_LANDING_KEY);
    sessionStorage.removeItem(LOGIN_PREFILL_LANDING_KEY);
    if (!raw) {
      return null;
    }
    const data = JSON.parse(raw) as LoginPrefillFromLanding;
    if (
      data?.fromLanding !== true ||
      data.tipoDocumento == null ||
      data.tipoDocumento === '' ||
      !String(data.numeroDocumento ?? '').trim()
    ) {
      return null;
    }
    return {
      ...data,
      numeroDocumento: String(data.numeroDocumento).trim(),
    };
  } catch {
    sessionStorage.removeItem(LOGIN_PREFILL_LANDING_KEY);
    return null;
  }
}
